














































import { Component, Prop, Vue } from 'vue-property-decorator'
import Local from '@/app/module/local'

@Component
export default class ProfitList extends Vue {
  private gradeList: Array<{[key:string]: string|number}> = []
  @Prop() fieldData!: any
  @Prop() type!: string
  @Prop() listType!: string

  created () {
    // 等級の配列を作成
    const constantValue = JSON.parse(Local.getConstantValue()!)
    this.gradeList = constantValue.grades
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-等級'
  }

  private displayValue (val: string|number) {
    return val !== null && val !== undefined ? val : '-'
  }

  /* カンマ区切り */
  public toLocale (val: string|number) {
    return val !== null && val !== undefined ? val.toLocaleString() : '-'
  }
}
